import axiosapi from "./axiosAPI";

// Get All SubCategories
export const getAllSubCategories = async (
    setSubCategories,
    setFetcherror,
    setIsLoading
) => {
    
	try{
		const res =await axiosapi.get("/subcategories");
        setSubCategories(res.data.data ? res.data.data : {});
        setIsLoading(false);
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch SubCategories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch SubCategories");
		}
		
	}
	
};



// Get All SubCategories Per Category
export const getCategorySubCategories = async (
    setSubCategories,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/categorysubcategories/${pkid}`);
        setSubCategories(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch SubCategories");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch SubCategories");
		}
		
	}
	
};



// Get One SubCategory
export const getOneSubCategory = async (
    pkid,
    setFetcherror,  
    setSubCategory
    
)=>{
	try{
		const res =await axiosapi.get(`/subcategories/${pkid}`);
        setSubCategory(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch SubCategory");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch SubCategory");
		}
		
	}
	
};


// Create New SubCategory
export const createSubCategory = async (
    subCategory,
    setSubCategory,
    setFetcherror,
    handleAllToasts,
    pkid,
    setSubCategories,
    setIsLoading

) => {
     console.log(pkid,"ID OF CATEGORY")

    if (!subCategory || !pkid ) {
        handleAllToasts(2, "No SubCategory Provided or Category not Selected"); 
            return; 
        }

    const PushItem = {
        name: subCategory,
        category_id:pkid
        };

    try{
        await axiosapi.post("/subcategories/",PushItem );
        setSubCategory("");
        handleAllToasts(1, "SubCategory Created Successfully");
        getAllSubCategories(setSubCategories, setFetcherror,setIsLoading);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New SubCategory");
            handleAllToasts(2, "Could Not update The SubCategory");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New SubCategory");
            handleAllToasts(2, "Could Not update The SubCategory");
            
        }
        
    }
    
}


// Edit Existing SubCategory

export const editSubCategory = async (
    pkid,
    subCategory,
    setSubCategory,
    setFetcherror,
    handleAllToasts,
    setSubCategories,
    setIsLoading
              
        ) => {

            if (!subCategory) {
                handleAllToasts(2, "No SubCategory Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:pkid,
                    name: subCategory,
                };

            try{
                await axiosapi.patch("/subcategories/",PushItem );
                setSubCategory("");
                handleAllToasts(1, "SubCategory Updated Successfully");
                getAllSubCategories(setSubCategories, setFetcherror,setIsLoading);
                
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update SubCategory");
                    handleAllToasts(2, "Could Not Update SubCategory");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update SubCategory");
                    handleAllToasts(2, "Could Not Update SubCategory");
                    
                }
                
            }
            
};



// Delete Existing SubCategory.

export const deleteSubCategory = async (
    pkid,
    setSubCategories,
    setFetcherror,
    handleAllToasts,
    setIsLoading
)=>{
    try {
        const res = await axiosapi.delete(`/subcategories/${pkid}`);
        let finalData = res.data.message;
        getAllSubCategories(setSubCategories, setFetcherror,setIsLoading);
        handleAllToasts(1, "SubCategory Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete SubCategory");
            handleAllToasts(2,"Error: Could Not Delete SubCategory");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete SubCategory");
            handleAllToasts(2,"Error: Could Not Delete SubCategory");
		}
		
	}
	
};